import { useMutation, UseMutationOptions } from "@connectrpc/connect-query";

import { downloadSourceArtifact } from "@gx/ts-contracts/services/source/api/source_artifact-SourceArtifactService_connectquery";

// ========== DOWNLOAD SOURCE ARTIFACT ==========

export const useDownloadSourceArtifactMutation = (
  options?: UseMutationOptions<
    typeof downloadSourceArtifact.input,
    typeof downloadSourceArtifact.output
  >,
) => {
  return useMutation<typeof downloadSourceArtifact.input, typeof downloadSourceArtifact.output>(
    downloadSourceArtifact,
    options,
  );
};
